<template>
  <div class="container">
    <div class="header hidden-xs-only" :style="style" :class="{color: color}">
      <el-row>
        <el-col :span="24">
          <div class="header-count hidden-xs-only flex-align-center flex-between">
            <div class="menu-box flex-align-center">
              <div class="logo">
                <router-link to="/">
                  <img src="../../assets/image/logo.png" alt="">
                </router-link>
              </div>
              <ul class="flex-align-center">
                <li v-for="(item, index) in tabList" :key="index" :class="{active:active == index}">
                  <a target="_blank" v-if="index == 5" :href="item.path">{{item.title}}</a>
                  <router-link v-else :to="item.path">{{item.title}}</router-link>
                </li>
              </ul>
            </div>
            <div class="header-right flex-align-center">
              <p class="right-item" @click="downloadClick">下载客户端</p>
              <div class="shu mr5 ml5">丨</div>
              <div class="flex-align-center">
                <a class="right-item" href="https://v.renderg.com/#/login" target="_blank">登录</a>
                <span class="mr5 ml5">/</span>
                <a class="right-item" href="https://v.renderg.com/#/register?flag=register&origin=web" target="_blank">注册</a>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="min-header hidden-sm-and-up flex-align-center flex-between">
      <div class="logo">
        <router-link to="/">
          <img src="../../assets/image/logo.png" alt="">
        </router-link>
      </div>
      <div class="nav-icon flex-align-center flex-center" @click="minDrawer = true">
        <img src="../../assets/image/nav-icon.png" alt="">
      </div>
    </div>
    <el-drawer
      class="hidden-sm-and-up"
      custom-class="drawer-box"
      size="37.5%"
      :visible.sync="minDrawer"
      :direction="direction"
      :modal-append-to-body='false'
      :show-close='false'>
      <div class="drawer-box">
        <el-menu 
          class="el-menu-vertical-demo"
          :default-active="$route.path"
          router>
          <el-menu-item index="/" class="flex-align-center flex-center" >
            <span slot="title" style="margin-left: -1px;">首页</span>
          </el-menu-item>
          <el-menu-item index="/render" class="flex-align-center flex-center">
            <span slot="title" style="margin-left: -1px;">渲染</span>
          </el-menu-item>
          <el-menu-item index="/case" class="flex-align-center flex-center">
            <span slot="title" style="margin-left: -1px;">案例</span>
          </el-menu-item>
          <el-menu-item index="/price" class="flex-align-center flex-center">
            <span slot="title" style="margin-left: -1px;">价格</span>
          </el-menu-item>
          <el-menu-item index="/news" class="flex-align-center flex-center">
            <span slot="title" style="margin-left: -1px;">新闻</span>
          </el-menu-item>
          <el-menu-item >
            <a target="_blank" class="flex-align-center flex-center" href="https://help.renderg.com/">
              <span slot="title" style="margin-left: -1px;">帮助</span>
            </a>
          </el-menu-item>
        </el-menu>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import api from '../../assets/js/api'
export default {
  props: {
    active: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tabList: [
        {
          path: '/',
          title: '首页'
        },
        {
          path: '/render',
          title: '渲染'
        },
        {
          path: '/case',
          title: '案例'
        },
        {
          path: '/price',
          title: '价格'
        },
        {
          path: '/news',
          title: '新闻'
        },
        {
          path: 'https://help.renderg.com/',
          title: '帮助'
        },
      ],
      drawer: false,
      minDrawer: false,
      clientIn: true,
      plugIn: true,
      direction: 'rtl',
      download_client_url: '',
      download_plug_url: '',
      style: {
        backgroundColor: '',
        marginTop: '',
      },
      color: false,
      screenWidth: document.body.clientWidth,
      timer: false
    }
  },
  created() {
    // console.log(this.screenWidth)
    this.getType(808)
  },
  mounted () {
    window.addEventListener("scroll", this.handleScroll);
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    buttonEnter (value) {
      switch (value) {
        case 1:
          this.clientIn = false
          this.plugIn = true
          this.getType(808)
          break;
        case 2:
          this.clientIn = true
          this.plugIn = false
          this.getType(804)
          break;
        default:
          break;
      }
    },
    buttonLeave (value) {
      this.clientIn = true
      this.plugIn = true
    },
    getType (type) {
      api.getVersion(type)
        .then((res) => {
          switch (type) {
            case 808:
              this.download_client_url = res.download_url_cdn
              break;
            case 804:
              this.download_plug_url = res.download_url_cdn
              break;
          
            default:
              break;
          }
        })
    },
   
    // 向下滚动 头部背景色变化
    handleScroll () {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // let offsetTop = document.querySelector(".header").offsetTop;
      //设置背景颜色的透明度
      if (scrollTop) {
        this.style.marginTop = 0
        this.style.backgroundColor = `rgba(0, 0, 0,${scrollTop / (scrollTop + 80)})`;
        this.color = true;
      } else if (scrollTop == 0) {
        this.style.backgroundColor = "transparent";
        this.style.marginTop = "";
        this.color = false;
      }
    },
    // 注册
    register () {
      window.location.href = 'https://v.renderg.com/#/register?flag=register&origin=web'
    },
    login () {
      window.location.href = 'https://v.renderg.com/#/login'
    },
    downloadClick () {
      if (this.$route.path == '/render') {
        window.location.href = this.download_client_url
      } else {
        this.$router.push('/render')
      }
    },
    download () {
      this.$message({
        message: '请使用电脑下载客户端',
        type: 'warning'
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch:{
    screenWidth(val) {
      // console.log(val)
      this.screenWidth = val
      if (this.screenWidth > 768) {
        this.minDrawer = false
      }
    }
  }
  // metaInfo: {
  //   meta: [
  //     {
  //       name: 'keywords',
  //       content: '云渲染,渲染农场,renderg渲染农场,renderg'
  //     },
  //     {
  //       name: 'description',
  //       content: 'renderg云渲染农场,渲染客户端,效果图渲染,免费渲染,渲染集群,3dmax,max渲染,maya渲染,houdini渲染,在线渲染,c4d渲染,是国内领先的云渲染平台'
  //     }
  //   ]
  // },
}
</script>